<template>
  <div class="longtermuseradd">
    <BaseTitle titleText="新增長照用戶" />
    <LongTermUserForm
      :areaTypeOptions="areaTypeOptions"
      :classOptions="classOptions"
      :districtOptions="districtOptions"
      :serviceOptions="serviceOptions"
      :longTermUser="user"
      @userDataHandler="userDataHandler"
      @onSubmit="onSubmit"
      @onReset="onReset"
    />
  </div>
</template>

<script>
import BaseTitle from '@/components/base/BaseTitle';
import LongTermUserForm from '@/components/longTerm/LongTermUserForm';

import { mapGetters, mapActions } from 'vuex';
import { errorMessageParse } from '@/utils/errorMessage';

export default {
  name: 'LongTermUserAdd',
  components: {
    BaseTitle,
    LongTermUserForm
  },
  methods: {
    ...mapActions({
      addUser: 'longTerm/addUser'
    }),
    userDataHandler({ value, property }) {
      const data = this.user;
      data[property] = value;
      this.$store.commit('longTerm/user', data);
    },
    async onSubmit(userData) {
      try {
        await this.addUser(userData);
        this.$store.commit('longTerm/userData', {});
        this.$bvToast.toast('長照用戶新增成功', {
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        });
      } catch (err) {
        console.warn(err);
        this.$store.commit('errorMessage', errorMessageParse(err));
        this.$root.$emit('bv::show::modal', 'error-modal');
      }
    },
    onReset() {
      this.$store.commit('longTerm/userData', {});
      this.$router.go(-1);
    }
  },
  computed: {
    ...mapGetters({
      areaTypeOptions: 'longTerm/areaTypeOptions',
      classOptions: 'longTerm/classOptions',
      districtOptions: 'longTerm/districtOptions',
      serviceOptions: 'longTerm/serviceOptions',
      user: 'longTerm/user'
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('longTerm/userData', {});
    next();
  }
};
</script>

<style lang="scss" scoped>
.longtermuseradd {
  width: 65%;
  max-width: 950px;
  margin: 0 auto;
}
</style>
